import React, { useState } from 'react';
import ControlSection from '../components/control-section';
import ItemPairList from '../../common/item-pair-list'
import EntityItem from './components/entity-profile-item';
import EntityForm from './components/entity-profile-form';
import { EntityProfileParams } from 'app/models/entity-profile-params';
import { useSelector } from 'react-redux';
import { getEntityProfiles } from 'app/state/ducks/entity-profile/selectors';
import { exportToCSV } from 'app/utils/util-functions';

interface EntityProfileProps {
    formExpanded: boolean
    setFormExpanded: React.Dispatch<React.SetStateAction<boolean>>
    searchTerm: string
    setSearchTerm: React.Dispatch<React.SetStateAction<string>>
    expandedEntityId: string | null
    setExpandedEntityId: React.Dispatch<React.SetStateAction<string | null>>
    newEntity: EntityProfileParams
    setNewEntity: React.Dispatch<React.SetStateAction<EntityProfileParams>>
}

function EntityProfile({ formExpanded,
    setFormExpanded,
    expandedEntityId,
    setExpandedEntityId,
    searchTerm,
    newEntity,
    setNewEntity, }: EntityProfileProps) {
    const entityProfiles: EntityProfileParams[] = useSelector(getEntityProfiles)
    const [activePage, setActivePage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const startIdx = (activePage - 1) * itemsPerPage
    const endIdx = startIdx + itemsPerPage
    const filteredEntities = entityProfiles.filter((entity) =>
        entity.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => a.name.localeCompare(b.name))
    const currentEntities = filteredEntities.slice(startIdx, endIdx)
    const handleItemsPerPageChange = (value: string) => {
        setItemsPerPage(parseInt(value, 10))
        setActivePage(1)
    }

    const handleOpenFormForEdit = (entityToEdit: EntityProfileParams) => {
        setFormExpanded(false)
        setNewEntity(entityToEdit)
        setExpandedEntityId(entityToEdit.id || null)
    }

    return (
        <div style={{ paddingTop: '20px' }}>
            {formExpanded && (
                <EntityForm
                    newEntity={undefined}
                    setFormExpanded={(expanded) => {
                        setFormExpanded(expanded)
                    }}
                />
            )}

            <ItemPairList<EntityProfileParams>
                items={currentEntities}
                expandedItemId={expandedEntityId}
                setExpandedItemId={setExpandedEntityId}
                onEdit={handleOpenFormForEdit}
                newItem={newEntity}
                ItemComponent={({ item, isExpanded }) => (
                    <EntityItem
                        entity={item}
                        isExpanded={isExpanded}
                        onEdit={handleOpenFormForEdit}
                    />
                )}
                FormComponent={({ newItem, setFormExpanded }) => (
                    <EntityForm
                        newEntity={newItem}
                        setFormExpanded={setFormExpanded}
                    />
                )}
            />

            <div style={{ paddingTop: '20px' }}>
                <ControlSection
                    itemsPerPage={itemsPerPage}
                    activePage={activePage}
                    totalItems={filteredEntities.length}
                    onItemsPerPageChange={handleItemsPerPageChange}
                    onPageChange={setActivePage}
                    onExport={() => exportToCSV(entityProfiles, 'entity-profiles.csv')}
                />
            </div>
        </div>
    )
}

export default EntityProfile